// extracted by mini-css-extract-plugin
export default {"CaptchaContainer":"Captcha_CaptchaContainer__BJWTV","CaptchaForm":"Captcha_CaptchaForm__l4WNR","ReCaptcha":"Captcha_ReCaptcha__L-QbK"};